import { render, staticRenderFns } from "./SettingParamForm.vue?vue&type=template&id=834825ae&"
import script from "./SettingParamForm.vue?vue&type=script&lang=js&"
export * from "./SettingParamForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports